import React, {useState} from "react";
import {TorzsgardaCalc} from "@/components/editor/TorzsgardaDetails.tsx";

export default function TorzsgardaGraph({
                                            year, setYear, calc, graph, currency
                                        }: {
    year: number,
    setYear: (year: number) => void,
    calc: TorzsgardaCalc | null,
    graph: "input" | "tax"
    currency: string
}) {

    const maxYear = 10;

    const [container, setContainer] = useState<HTMLDivElement | null>();

    function thumbPosition() {
        return (year / maxYear) * (container?.clientWidth ?? 0) * 0.9;
    }


    function handleMouseMove(e: MouseEvent) {
        if (container) {
            const rect = container.getBoundingClientRect();
            const x = e.clientX - (rect.left);
            const newYear = Math.round((x / (rect.width * 0.9)) * maxYear);
            if (newYear < 0) {
                setYear(0);
                return;
            }
            if (newYear > maxYear) {
                setYear(maxYear);
                return;
            }
            setYear(newYear);
        }
    }

    function onHandleMouseDown(e: React.MouseEvent<HTMLDivElement>) {
        e.preventDefault();
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", onHandleMouseUp);
    }

    function onHandleMouseUp() {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", onHandleMouseUp);
    }

    function getTopValues() {
        switch (graph) {
            case "tax":
                return calc?.lojalitas.ado;
            case "input":
                return calc?.lojalitas.befizetes;
        }
    }

    function getBottomValues() {
        switch (graph) {
            case "tax":
                return calc?.torzsgarda.ado;
            case "input":
                return calc?.torzsgarda.befizetes;
        }
    }

    function getTopAmount() {
        return getTopValues()?.[year - 1] ?? 0;
    }

    function getBottomAmount() {
        return getBottomValues()?.[year - 1] ?? 0;
    }

    function topLinePosition() {
        return (year / maxYear) * top();
    }

    function bottomLinePosition() {
        return (year / maxYear) * middleY();
    }

    function middleY() {
        const factor = (getBottomValues()?.[(getBottomValues()?.length ?? 0) - 1] ?? 2) / (getTopValues()?.[(getTopValues()?.length ?? 0) - 1] ?? 1)
        if(factor > 1) {
            return (container?.clientHeight ?? 0)
        } else {
            return (container?.clientHeight ?? 0) * factor
        }

    }

    function right() {
        return (container?.clientWidth ?? 0);
    }

    function top() {
        const factor = (getBottomValues()?.[(getBottomValues()?.length ?? 0) - 1] ?? 2) / (getTopValues()?.[(getTopValues()?.length ?? 0) - 1] ?? 1);
        if(factor > 1) {
            return (container?.clientHeight ?? 0) / factor
        } else {
            return (container?.clientHeight ?? 0)
        }
    }
    function graphTop() {
        return (container?.clientHeight ?? 0)
    }

    function graphRight() {
        return right() * 0.9;
    }


    return (<>
        <div className={"w-full h-full flex"}>
            <div className={"relative h-full w-64"}></div>
            <div className={"w-full h-full relative"} ref={newRef => setContainer(newRef)}>
                <svg className={"w-full h-full -scale-y-100"}>
                    <defs>
                        <pattern id="tenthGrid" width="10" height="10" patternUnits="userSpaceOnUse">
                            <path d="M 10 0 L 0 0 0 10" fill="none" stroke="silver" stroke-width="0.5"/>
                        </pattern>
                        <pattern id="grid" width="50" height="50" patternUnits="userSpaceOnUse">
                            <rect width="50" height="50" fill="url(#tenthGrid)"/>
                            <path d="M 50 0 L 0 0 0 50" fill="none" stroke="gray" stroke-width="1"/>
                        </pattern>
                    </defs>
                    <rect width="100%" height="100%" fill="url(#grid)"/>
                    <path d="M 0 10000 L 0 0" fill="none" stroke="#55aeb7" stroke-width="2"/>
                    <path d="M 0 0 L 10000 0" fill="none" stroke="#55aeb7" stroke-width="2"/>

                    <path className={"transition-all"} d={`M ${thumbPosition()} 10000 L ${thumbPosition()} 0`}
                          fill="none" stroke="#55aeb7" stroke-width="2"/>

                    <path className={"transition-all"} d={`M 0 0 L ${graphRight()} ${top()}`} fill="none" stroke="gray"
                          stroke-width="2"/>
                    <path className={"transition-all"}
                          d={`M ${thumbPosition()} ${topLinePosition()} L ${right()} ${topLinePosition()}`} fill="none"
                          stroke="black" stroke-width="2"/>

                    <path className={"transition-all"} d={`M 0 0 L ${graphRight()} ${middleY()}`} fill="none"
                          stroke="#55aeb7" stroke-width="2"/>
                    <path className={"transition-all"}
                          d={`M ${thumbPosition()} ${bottomLinePosition()} L ${right()} ${bottomLinePosition()}`}
                          fill="none" stroke="#55aeb7" stroke-width="2"/>

                    <defs>
                        <clipPath id="cut-fill">
                            <rect className={"transition-all"} x="0" y="0" width={thumbPosition()} height={graphTop()}/>
                        </clipPath>
                        <linearGradient id="grad1" x1="0%" x2="100%" y1="0%" y2="0%">
                            <stop offset="0%" stop-color="#00000000"/>
                            <stop offset="100%" stop-color="red"/>
                        </linearGradient>
                    </defs>
                    <polygon className={"transition-all"}
                             points={`${0},${0} ${graphRight()},${top()} ${graphRight()},${middleY()}`}
                             fill="url(#grad1)" clipPath={"url(#cut-fill)"}/>

                </svg>
                <div onMouseDown={(e) => onHandleMouseDown(e)}
                     className={"transition-all bg-white w-6 h-6 rounded-full border-6 border-primary -translate-x-1/2 -translate-y-1/2 absolute cursor-pointer"}
                     style={{left: thumbPosition() + "px"}}></div>
                <div className={"transition-all -translate-x-1/2 -bottom-10 absolute"}
                     style={{left: thumbPosition() + "px"}}>
                    <p className={"text-gray"}>{year} év</p>
                </div>
                <div>

                </div>
            </div>
            <div className={"relative h-full w-64"}>
                {year > 0 && <>
                    <div className={"absolute text-gray h-8 flex items-center ml-3 transition-all"}
                         style={{bottom: `calc(${Math.abs(topLinePosition() - bottomLinePosition()) < 30 ? topLinePosition() + (15 * ((bottomLinePosition() < topLinePosition()) ? 1 : -1)) : topLinePosition()}px - 1rem)`}}>
                        <p>{getTopAmount().toLocaleString('hu-HU', {maximumFractionDigits: 0})} {currency}</p>
                    </div>
                    <div
                        className={"absolute bg-[#55aeb7] text-white rounded-full px-4 h-8 flex items-center ml-3 transition-all"}
                        style={{bottom: `calc(${Math.abs(topLinePosition() - bottomLinePosition()) < 30 ? bottomLinePosition() - (15 * ((bottomLinePosition() < topLinePosition()) ? 1 : -1)) : bottomLinePosition()}px - 1rem)`}}>
                        <p>{getBottomAmount().toLocaleString('hu-HU', {maximumFractionDigits: 0})} {currency}</p>
                    </div>
                </>
                }
            </div>
        </div>
    </>)
}